import {
  CardItemContainer,
  CardItem,
  SkeletonBox
} from '@presentation/components';
import type { FC } from 'react';
import * as RootStyled from '../../styled';

export const PageSkeleton: FC = () => {
  return (
    <CardItemContainer>
      {Array(4)
        .fill(undefined)
        .map((_, index) => (
          <RootStyled.CardItemWrapper key={index}>
            <CardItem
              loading
              content={{
                title: <SkeletonBox style={{ width: '100%', height: 21.5 }} />,
                text: <SkeletonBox style={{ width: '100%', height: 21.5 }} />,
              }}
            />
          </RootStyled.CardItemWrapper>
        ))
      }
    </CardItemContainer>
  );
};
